

/**
 * Enum que representa los IDs internos de la tabla `configuracion.tram_solicitud_estados`.
 */
export enum TramiteSolicitudEstados {
    FIRMA_PENDIENTE = 'FIRMA_PENDIENTE',
    PAGO_PENDIENTE = 'PAGO_PENDIENTE',
    PROCESANDO_PAGO = 'PROCESANDO_PAGO',
    PENDIENTE_APROBACION = 'PENDIENTE_APROBACION',
    PAGADO = 'PAGADO',
    ACTIVO = 'ACTIVO',
}
